import { useEffect, useRef, useState } from "react";

// The reading behind one line, fetched when a reader asks for it.
//
// The map carries the shape of the web; it stopped carrying every quotation
// when the corpus reached three hundred edges and the payload reached half a
// megabyte. Clicking a line is a deliberate act and can afford a request.
// Answers are kept, so going back to a line you have already read is instant.
export default function useEvidence(edge) {
  const cache = useRef(new Map());
  const [state, setState] = useState({ status: "idle", assertions: [] });

  useEffect(() => {
    if (!edge) return undefined;

    const key = edge.claimIds.join(",");
    if (cache.current.has(key)) {
      setState({ status: "ready", assertions: cache.current.get(key) });
      return undefined;
    }

    let live = true;
    setState({ status: "loading", assertions: [] });

    fetch(`/correspondences/evidence?claims=${encodeURIComponent(key)}`, {
      headers: { Accept: "application/json" }
    })
      .then((response) => (response.ok ? response.json() : Promise.reject(response.status)))
      .then((body) => {
        cache.current.set(key, body.assertions);
        if (live) setState({ status: "ready", assertions: body.assertions });
      })
      .catch(() => {
        // Say so rather than showing an empty evidence list, which would read
        // as "there is none".
        if (live) setState({ status: "failed", assertions: [] });
      });

    return () => { live = false; };
  }, [edge]);

  return state;
}
